<template>
  <v-app>
    <div class="app-wrapper">
      <v-app-bar app
                 flat
                 color="#1d313d"
                 height="80px"
      >
        <div class="bar">
          <div class="logo"
               @click="goToMainView"
          >
            <img src="./assets/Logo_Glimpse_128x128.png"
                 style="width: 64px"
            />
            <div class="logo-box">
              <div class="logo-text">GLIM</div>
              <img src="./assets/logo.png"
                   style="width: 95px"
                   class="telestream-logo"
              />
            </div>
          </div>
          <div class="bar-controls padding-one-right">
            <License class="padding-one-right"></License>
            <ApplicationMenu></ApplicationMenu>
          </div>
        </div>
      </v-app-bar>
      <v-content>
        <router-view />
      </v-content>
    </div>
  </v-app>
</template>

<script>
import License from './components/app-user-info/License';
import ApplicationMenu from './components/header/components/ApplicationMenu';
import { FETCH_USER_INFO } from '@/utils/action-types';
import { BusService } from '@/services/bus.service';

export default {
  name:       'ListFrame',
  components: {
    ApplicationMenu,
    License,
  },
  mounted() {
    this.$store.dispatch(FETCH_USER_INFO);
  },
  methods: {
    goToMainView() {
      if (this.$router.currentRoute.name !== 'MainView') {
        this.$router.push('/');
      } else {
        BusService.unloadVideo.next();
      }
    },
  },
};
</script>

<style lang="scss">
@import 'styles/common.scss';

* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

.app-wrapper {
    width: 1000px;
    margin: 0 auto;
}

.bar {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    align-items: center;
}

.bar-controls {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.logo {
    cursor: pointer;
    padding-left: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.logo-text {
    font-family: Poppins, sans-serif;
    color: #009bdf;
    font-size: 36px;
    padding-top: 24px;
    letter-spacing: 6px;
}

.logo-box {
    margin-left: 20px;
    position: relative;
    height: 80px;
}

.telestream-logo {
    position: absolute;
    top: 10px;
    left: 3px;
}

.content {
    padding-top: 20px;
}
</style>
